






import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'OrganizerOffersLineChart'

  vue:
    props: ['data', 'options']

    components: {
      BoxChart,
    }

    data: ->
      chart: null

    computed:
      opt: ->
        @options || {}

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        series = @data
        labels = Object.keys(series.accepted).map(@formatDateLabel)

        @chart = new Chart(@$refs.chart, {
          type: 'line'
          data: {
            labels: labels
            datasets: [
              {
                label: 'Pending'
                data: Object.values(series.pending)
                borderColor: ChartUtility.COLORS.orange
                pointBorderColor: ChartUtility.COLORS.orange
                pointBackgroundColor: ChartUtility.COLORS.orange
              }
              {
                label: 'Other'
                data: Object.values(series.other)
                borderColor: ChartUtility.COLORS.pink
                pointBorderColor: ChartUtility.COLORS.pink
                pointBackgroundColor: ChartUtility.COLORS.pink
              }
              {
                label: 'Accepted'
                data: Object.values(series.accepted)
                fill: true
                borderColor: ChartUtility.COLORS.blue
                backgroundColor: 'rgba(52, 144, 220, 0.3)'
                pointBorderColor: ChartUtility.COLORS.blue
                pointBackgroundColor: ChartUtility.COLORS.blue
              }
            ]
          }
          options: {
            maintainAspectRatio: false
            cubicInterpolationMode: 'monotone'
            tension: 0.4
            interaction: {
              intersect: false
              axis: 'x'
              mode: 'nearest'
            }
            scales: {
              x: {
                grid: {
                  display: false
                }
                ticks: {
                  maxRotation: 0
                }
              }
              y: {
                ticks: {
                  precision: 0
                }
              }
            }
            plugins: {
              legend: {
                display: false
              }
            }
          }
        })

      formatDateLabel: (date) ->
        if dayjs(date).year() is dayjs().year()
          dayjs(date).format('MMM')
        else
          dayjs(date).format('MMM YY')

export default VueOptions.vue settings
